import { getCredentials } from "./getCredentials";
import { removeCredentials } from "./removeCredentials";
import { setCredentials } from "./setCredentials";

export const authCredentials = {
  get: getCredentials,
  set: setCredentials,
  remove: removeCredentials,
};
